import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { StatusDialogService } from '@common/services/status-dialog-service/status-dialog-service.service';
import { ConfigService } from '@common/services/config/config.service';

@Injectable()
export class NetworkErrorInterceptor implements HttpInterceptor {
  constructor(private statusDialogService: StatusDialogService, private configService: ConfigService) {}

  /* eslint-disable @typescript-eslint/no-explicit-any */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(() => {
        const ignoreReqUrls = ['favicon.ico', 'contactcenter/v1/api/log'];
        const isIgnoreRequest = ignoreReqUrls.some((urlToIgnore) => req.url.includes(urlToIgnore));
        const getRandomString = (): string => {
          return Math.random().toString(36).substring(2, 15);
        };

        const isOnline = (): void => {
          const url = new URL(window.location.origin);
          url.searchParams.set('rand', getRandomString());

          try {
            fetch(url.toString(), { method: 'HEAD' })
              .then(() => this.statusDialogService.hide())
              .catch(() => this.statusDialogService.show());
          } catch {
            this.statusDialogService.show();
          }
        };

        if (this.configService?.connectionCheckerSettings?.IsEnabled && !isIgnoreRequest) {
          if (navigator.onLine) {
            isOnline();
          } else {
            this.statusDialogService.show();
          }
        }

        return throwError(() => new Error('Http  error'));
      }),
    );
  }
}
